import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "moudle2" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"left\"><p><span>How we work</span></p></div><div class=\"right\"><p class=\"gree\">DATA<br>DRIVEN</p><p class=\"around around_bg1\"><span>Monetize</span></p><p class=\"around around_bg2\"><span>Advertise</span></p><p class=\"around around_bg3\"><span>Maximize <br>User Value</span></p><p class=\"around around_bg4\"><span>Acquire users</span></p></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}